import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Pipe({
  standalone: true,
  name: 'translatePlural',
  pure: false,
})
export class TranslatePluralPipe implements PipeTransform {
  private readonly _translate = inject(TranslateService);

  transform(count: number, keyPrefix: string): string {
    const lang = (this._translate.currentLang || this._translate.defaultLang).toLowerCase();
    const pluralKey = this._getPluralKey(count, lang);
    const fullKey = `${keyPrefix}.${pluralKey}`;

    return this._translate.instant(fullKey, { count });
  }

  private _getPluralKey(count: number, lang: string): string {
    const pr = new Intl.PluralRules(lang || 'en');

    return pr.select(count);
  }
}
